export default {
  errorScreen: {
    actions: {
      createNewAppointment: 'Create new appointment',
      goBack: 'Close',
    },
    header: 'Booking error',
    messages: {
      default: 'An unexpected error occurred. Please try again later',
      internalServerError: 'Internal server error. Please try again later',
      network: 'Network error. Please check your connection and try again.',
      noLocations: 'No locations available',
      zdCode: 'Invalid referral code',
    },
  },
  fields: {
    dateOfBirth: {
      error: 'Please enter a valid date of birth',
      label: 'Date of birth',
      placeholder: 'DD/MM/YYYY',
    },
    email: {
      error: 'Please enter a valid email address',
      label: 'Email address',
      placeholder: 'john.doe@mail.com',
    },
    firstName: {
      error: 'Please enter your name',
      label: 'Name',
      placeholder: 'John',
    },
    gender: {
      error: 'Please select your gender',
      label: 'Gender',
      options: {
        female: 'Female',
        male: 'Male',
        other: 'Other',
        unknown: 'Unknown',
      },
    },
    height: {
      error: 'Please enter a valid height',
      label: 'Height (cm)',
    },
    initials: {
      error: 'Please enter your initials',
      label: 'Initials',
      placeholder: 'JD',
    },
    lastName: {
      error: 'Please enter your surname',
      label: 'Surname',
      placeholder: 'Doe',
    },
    phone: {
      error: 'Please enter a valid telephone number',
      label: 'Telephone number',
      placeholder: 'XXX-XXX XXXX',
    },
    weight: {
      error: 'Please enter a valid weight',
      label: 'Weight (kg)',
    },
  },
  navHeader: 'Book an appointment',
  successScreen: {
    actions: {
      close: 'Close',
    },
    header: 'Appointment confirmed',
  },
}
